import { Component, computed, Input, OnInit, signal } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { InputTextareaComponent } from 'src/app/shared/components/form-elements/input-textarea/input-textarea.component'
import { InputComponent } from 'src/app/shared/components/form-elements/input/input.component'
import { PostcodeLookupComponent } from 'src/app/shared/components/form-elements/postcode-lookup/postcode-lookup.component'
import { PostcodeAddress } from 'src/app/shared/interfaces/postcode-lookup/postcode-address.interface'

@Component({
    selector: 'sf-smartquote-customer-details',
    imports: [ReactiveFormsModule, CardComponent, InputComponent, InputTextareaComponent, PostcodeLookupComponent],
    templateUrl: './smartquote-customer-details.component.html',
    styleUrl: './smartquote-customer-details.component.scss',
})
export class SmartquoteCustomerDetailsComponent implements OnInit {
    @Input() form!: FormGroup

    existingWorkAddress = signal(null)

    selectAddress(address: PostcodeAddress) {
        this.form.patchValue({
            addressLine1: address.line1,
            addressLine2: address.line2,
            town: address.townOrCity,
            county: address.county,
            postcode: address.postcode,
        })
    }

    ngOnInit(): void {
        this.form.valueChanges.subscribe(({ workAddress }) => this.existingWorkAddress.set(workAddress))
    }
}
